export class ResourceNameCondition {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "operator",
            "baseName": "operator",
            "type": "ScalarOperators",
            "format": ""
        },
        {
            "name": "resourceNames",
            "baseName": "resourceNames",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ResourceNameCondition.attributeTypeMap;
    }
    constructor() {
    }
}
